export default __webpack_public_path__ + "static/media/about-benefits-listing-detail-sidebar.35d7538c.jpg";